const PredictionGetter = {
    predictions: state => state.predictions,
    strategies: state => state.strategies,
    market: state => state.market
};

export default PredictionGetter;